import { Steps as StepsCommon } from './common';
import { NavigationButtons } from './components/NavigationButtons';
import { NavigationButtonsNorlys } from './components/NavigationButtonsNorlys';
import { StepsWrapper, StepsWrapperNorlys } from './style';
import { StepsProps } from './types';
import { StepsIcon, StepsIconNorlys } from './util';

export const Steps = (props: StepsProps) => (
  <StepsWrapper>
    <StepsCommon {...{ NavigationButtons, CustomIcon: StepsIcon, ...props }} />
  </StepsWrapper>
);

export const StepsNorlys = (props: StepsProps) => (
  <StepsWrapperNorlys>
    <StepsCommon
      {...{
        showDivider: true,
        showChevron: true,
        CustomIcon: StepsIconNorlys,
        NavigationButtons: NavigationButtonsNorlys,
        ...props,
      }}
    />
  </StepsWrapperNorlys>
);
